module.exports = __webpack_public_path__ + "img/upgrade-site.875ab8c4.jpg";